import { IDs } from '../../../../../helpers/IDs';
import parse from 'html-react-parser';
import * as React from 'react';
import { renderText } from '../../assistent_helpers';
import style from '../../Assistent.less';

interface SachanlagenElementProps extends React.ClassAttributes<any> {
    data: any;
}

export class SachanlagenElement extends React.Component<SachanlagenElementProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div
                className={style.customFormInfotext}
                style={{ padding: 20 }}
            >
                {this.renderText()}
            </div>
        );
    }

    renderText(): JSX.Element | JSX.Element[] {
        const modul: string = (this.props.data || {}).MODUL_SELECTED || null;
        const html: any = renderText('Geführter Modus - Hinweis Sachanlagen', this.props.data, modul === 'cfm');

        if (modul === 'cfm') {
            return parse(html, {
                replace: domNode => {
                    if (domNode.type === 'text' && (domNode.data || '').toString().substring(0, 4) === '2.4.') {
                        return <>{domNode.data.replace('2.4', '2.5')}</>;
                    }
                }
            });
        }

        return html;
    }
}
